<template>
  <span class="deal-type-badge" :class="[badge.tone, size]">{{ badge.label }}</span>
</template>

<script>
/**
 * The deal-type pill every list uses (Now Raising, the Exchange rows, the Exchange page), so a
 * metal, an NGX stock and a fund read the same everywhere. The label and tone come from
 * listingView in utils/trade-view; the colours are the app's existing badge colours.
 */
export default {
  name: "DealTypeBadge",
  props: {
    // { label, tone } from listingView(token).badge
    badge: { type: Object, required: true },
    // "md" for cards, "sm" for compact rows
    size: { type: String, default: "md" },
  },
};
</script>

<style lang="scss" scoped>
.deal-type-badge {
  display: inline-block;
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 7px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  background: #E5EDFF;
  color: #4D84FF;

  &.sm {
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 10px;
  }

  &.debt { background: #FEF3C7; color: #D97706; }
  &.equity { background: #D1FAE5; color: #059669; }
  &.safe { background: #EDE9FE; color: #7C3AED; }
  &.fund { background: #E0F2FE; color: #0284C7; }
  &.commodity { background: #F6EED8; color: #8A6A1C; }
  &.ngx { background: #EEF2FF; color: #4F46E5; }
}
</style>
